import Cleave from 'cleave.js'

document.addEventListener('turbo:load', () => {
  // Initialize Cleave.js for currency inputs
  const currencyInputs = document.querySelectorAll('[data-currency]')

  currencyInputs.forEach(input => {
    new Cleave(input, {
      numeral: true,
      numeralDecimalScale: 2,
      numeralDecimalMark: '.',
      delimiter: ',',
      prefix: '',
      rawValueTrimPrefix: true,
      numeralPositiveOnly: true
    })
  })
})
